// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xGHwQ","input":"styles_input__2BK1F"};